import { LoggedApiConnector } from 'modelx/connectors/LoggedApiConnector';
import ConfigProxy            from 'tools/ConfigProxy';
import ExportApiModel         from './ExportApiModel';

export const exportLoggedApiConnector = new LoggedApiConnector({
	baseURL: ConfigProxy.getServiceConfig('export', 'api_endpoint'),
});

export default class ExportPrivateApiModel extends ExportApiModel {
	public static get connector() {
		return exportLoggedApiConnector;
	}
}
